/**
 * A practitioner picks one accent colour. Every surface that used to be hardcoded green needs
 * a lighter hover, a pale tint and a border derived from it, so her whole booking block follows
 * her choice instead of only a button or two.
 */

const clean = (hex) => {
  const s = String(hex || "").replace("#", "");
  return s.length === 3 ? s.split("").map(c => c + c).join("") : s.padEnd(6, "0").slice(0, 6);
};

export const mixHex = (hex, towards, t) => {
  const a = clean(hex), b = clean(towards);
  const part = (i) => {
    const av = parseInt(a.slice(i * 2, i * 2 + 2), 16);
    const bv = parseInt(b.slice(i * 2, i * 2 + 2), 16);
    return Math.round(av + (bv - av) * t).toString(16).padStart(2, "0");
  };
  return `#${part(0)}${part(1)}${part(2)}`;
};

export const accentShades = (accent) => ({
  base:   accent,
  light:  mixHex(accent, "#ffffff", 0.18),
  pale:   mixHex(accent, "#ffffff", 0.35),
  tint:   mixHex(accent, "#ffffff", 0.92),
  border: mixHex(accent, "#ffffff", 0.58),
  deep:   mixHex(accent, "#000000", 0.35),
});
